import React from 'react'
import './ClinicAddress.scss'

const ClinicAddress = ({ clinic, privateText }) => (
  <div className="ClinicAddress">
    <p>
      {clinic.address_1 ? `${clinic.address_1}, ` : ''}
      {clinic.address_2 ? `${clinic.address_2}, ` : ''}
      {`${clinic.city}, ${clinic.state}`}
      {clinic.address_1 ? '' : `, ${clinic.zip}`}
    </p>

    {clinic.address_private && (
      <p className="private-disclaimer">{privateText}</p>
    )}
  </div>
)

export default ClinicAddress
